// #region Imports
import React, { Component } from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from "formik";
import * as yup from 'yup';

//FluentUI
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import {
  DetailsListLayoutMode,
  SelectionMode,
  Selection,
  IColumn,
} from 'office-ui-fabric-react/lib/DetailsList';
import { ShimmeredDetailsList } from 'office-ui-fabric-react/lib/ShimmeredDetailsList';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { CommandBarButton, IconButton, ICommandBarStyles } from 'office-ui-fabric-react';
import { IDialogContentProps } from 'office-ui-fabric-react/lib/Dialog';
//MaterialUI
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
//Componentes
import Panel from "~/components/layout/Panel";
import Status from "~/components/Status";
import CustomDialog from "~/components/CustomDialogFluentUI";
import { InputText, InputCheckbox } from '~/components/Forms';
import HeaderPage from '~/components/layout/HeaderPage';
import NoItems from '~/components/layout/NoItems';
import { DeleteButton } from '~/components/Buttons';
import colors from "~/assets/js/colors";
import { CustomDrawer as Drawer } from "~/components/layout/Drawer";
import { Page, BreadcrumbItems } from "~/store/ducks/home/types";
//Estilos
import {
  Wrapper,
  ListContainer,
  DefaultButton,
  ContainerContent,
} from "./styles";

import { PrimaryButton } from '~/components/Buttons'
import { Creators as getCompanies } from "~/store/ducks/admin/companies";
import { Creators as addCompany } from "~/store/ducks/admin/companies";
import { Creators as delCompany } from "~/store/ducks/admin/companies";
import { Creators as editCompany } from "~/store/ducks/admin/companies";
import { Creators as setCurrentPage } from "~/store/ducks/home";
import { ICompany, DataTypes } from "~/store/ducks/admin/companies/types";
import { RootState } from "~/store/ducks";
//#endregion

const btnStyle: Partial<ICommandBarStyles> = {
  root: {
    height: 44
  }
}

/**
 * Validação do formulário
 */
const validationCompanySchema = yup.object().shape({
  codEmpresa: yup.string().required("Campo obrigatório"),
  nomeEmpresa:
    yup.string()
      .min(3, "O nome da empresa deve conter pelo menos 3 caracteres")
      .max(80, "O nome da empresa não pode ter mais do que 80 caracteres")
      .required("Campo obrigatório"),
  flagAtiva:
    yup.bool()
});

type Filter = {
  isOpen?: boolean;
  ativadas: string;
  filterStatus: boolean | null;
};

interface ICompaniesState {
  columns: IColumn[];
  items: ICompany[];
  isPanelOpen: boolean;
  inicialValues: ICompany;
  isFiltering: boolean;
  selectionDetails: string;
  selectionCount: number;
  isDialogExcludeOpen: boolean;
  filter: Filter;
  search: string;
};

interface IPropsCompany {
  companies: DataTypes;
  setCurrentPage: (page: Page) => void;
  getCompanies: (search?: string, filter?: boolean | null) => void;
  addCompany: (company: ICompany) => void;
  editCompany: (company: ICompany) => void;
  delCompany: (id: number) => void;
}

const itemsBreadCrumb: BreadcrumbItems[] = [
  { text: "Home", isCurrentItem: false, icon: "HomeSolid", onlyIcon: true, url: "/" },
  { text: "Empresas", isCurrentItem: true },
];

const initialValue: ICompany = {
  idEmpresa: null,
  codEmpresa: "",
  nomeEmpresa: "",
  flagAtiva: true
}

class Companies extends Component<IPropsCompany, ICompaniesState> {
  private formRef: any;
  private inputSearch: any;
  private _selection: Selection;

  constructor(props: IPropsCompany) {
    super(props);
    //#region Colunas
    const columns: IColumn[] = [
      {
        key: 'column1',
        name: '',
        ariaLabel: 'Status da empresa',
        fieldName: 'flagAtiva',
        minWidth: 15,
        maxWidth: 20,
        isResizable: true,
        isSortedDescending: false,
        onRender: (item: ICompany) => <Status status={item.flagAtiva} />
      },
      {
        key: 'column2',
        name: 'ID',
        ariaLabel: 'ID da empresa',
        fieldName: 'codEmpresa',
        isRowHeader: true,
        minWidth: 75,
        maxWidth: 100,
        isResizable: true,
        isSortedDescending: false,
        onColumnClick: this._onColumnClick
      },
      {
        key: 'column3',
        name: 'Razão Social',
        fieldName: 'nomeEmpresa',
        minWidth: 210,
        maxWidth: 350,
        isRowHeader: true,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false,
        sortAscendingAriaLabel: 'Sorted A to Z',
        sortDescendingAriaLabel: 'Sorted Z to A',
        onColumnClick: this._onColumnClick,
        data: 'string',
        isPadded: true,
      }
    ];
    //#endregion

    this.state = {
      columns: columns,
      items: [],
      isPanelOpen: false,
      selectionDetails: "",
      inicialValues: initialValue,
      isFiltering: false,
      selectionCount: 0,
      isDialogExcludeOpen: false,
      search: "",
      filter: {
        isOpen: false,
        ativadas: 'todos',
        filterStatus: null,
      }
    }

    this._selection = new Selection({
      onSelectionChanged: () => {
        this.setState({
          selectionDetails: this._getSelectionDetails(),
        });
      },
    });

    this.formRef = React.createRef();
    this.inputSearch = React.createRef();
  };

  componentDidMount() {
    const page: Page = {
      key: 'empresas',
      pages: itemsBreadCrumb
    };
    this.props.setCurrentPage(page);
    this.props.getCompanies();
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    if (this.state.isPanelOpen) {
      if (prevProps.companies.success !== this.props.companies.success) {
        if (this.props.companies.success) {
          this.setState({ isPanelOpen: false })
        }
      }
    }
  }

  // Submit do formulário Formik
  handleSubmit = () => {
    if (this.formRef.current) {
      this.formRef.current.handleSubmit();
    };
  };

  _onItemInvoked = (item: ICompany): void => {
    this.setState({
      isPanelOpen: true,
      inicialValues: {
        ...item
      }
    });
  };

  _getSelectionDetails(): any {
    const selectionCount = this._selection.getSelectedCount();
    this.setState({ selectionCount });
    this._selection.getSelection();
  };

  openEdit = () => {
    const selectItem: ICompany = (this._selection.getSelection()[0] as ICompany)
    this.setState({ isPanelOpen: true, inicialValues: selectItem });
  };

  cancelPanel = () => {
    this._selection.setAllSelected(false);
    this.setState({ isPanelOpen: false });
  };

  excludeCompanies = () => {
    this.props.delCompany((this._selection.getSelection()[0] as ICompany).idEmpresa!);
    this.setState({ isDialogExcludeOpen: false });
    this._selection.setAllSelected(false);
  };

  //#region  Funções do filtro

  toggleFilter = () => {
    this.setState({
      filter: {
        ...this.state.filter,
        isOpen: !this.state.filter.isOpen,
      }
    });
  };

  toggleParamsFilter = (param: string) => {
    const { filter, search } = this.state;

    switch (param) {
      case 'todos':
        this.setState({ filter: { ...filter, filterStatus: null, ativadas: param } },
          () => this.props.getCompanies(search)
        );
        break;
      case 'ativadas':
        this.setState({ filter: { ...filter, filterStatus: true, ativadas: param } },
          () => this.props.getCompanies(search, true)
        );
        break;
      case 'desativadas':
        this.setState({ filter: { ...filter, filterStatus: false, ativadas: param } },
          () => this.props.getCompanies(search, false)
        );
        break;
    }

    if (this.inputSearch.current) {
      this.filter(this.inputSearch.current.state.value);
    };

  };

  handleSearch = (e: any) => {
    const search: string = e?.target.value ? e!.target.value : "";
    this.setState({ search: search });
    if (search === "") {
      this.props.getCompanies("", this.state.filter.filterStatus);
    }
  };

  filter = (key: any) => {
    const { search, filter } = this.state;

    if (key === 'Enter') {
      if (filter.filterStatus !== null) {
        this.props.getCompanies(search, filter.filterStatus);
      } else {
        this.props.getCompanies(search);
      }
      if (this.inputSearch.current) {
        this.inputSearch.current.focus();
      }
    };

    if (search === "") {
      this.props.getCompanies("", filter.filterStatus);
    }
  };
  //#endregion

  commandBarRender = () => {
    const { selectionCount } = this.state;
    if (selectionCount === 1) {
      return (
        <>
          <CommandBarButton styles={btnStyle} iconProps={{ iconName: 'Edit' }} text="Editar" onClick={() => this.openEdit()} />
          <CommandBarButton styles={btnStyle} iconProps={{ iconName: 'Delete' }} text="Excluir" onClick={() => this.setState({ isDialogExcludeOpen: true })} />
        </>
      );
    } else if (selectionCount > 1) {
      return <CommandBarButton styles={btnStyle} iconProps={{ iconName: 'Delete' }} text="Excluir" onClick={() => this.setState({ isDialogExcludeOpen: true })} />
    };
  };

  render() {
    const { isPanelOpen, isDialogExcludeOpen, selectionCount, inicialValues, isFiltering, items, columns, filter, search } = this.state;
    const { companies, addCompany, editCompany, getCompanies } = this.props;

    const dialogContentProps: IDialogContentProps = {
      title: 'Excluir?',
      closeButtonAriaLabel: 'Close',
      subText: selectionCount <= 1 ? 'Tem certeza de que deseja excluir este item?' : 'Tem certeza de que deseja excluir estes items?',
    };

    return (
      <>
        <Panel
          title={!inicialValues.idEmpresa ? "Nova empresa" : inicialValues.nomeEmpresa}
          open={isPanelOpen}
          onClose={() => this.cancelPanel()}
          footer={
            <Stack horizontal tokens={{ childrenGap: 10 }}>
              <DefaultButton onClick={() => this.cancelPanel()}>Cancelar</DefaultButton>
              <PrimaryButton onClick={this.handleSubmit} isLoading={companies.loading} text="Salvar" />
            </Stack>
          }
        >
          <Formik
            innerRef={this.formRef}
            initialValues={{ ...inicialValues, flagAtiva: !inicialValues.flagAtiva }}
            validationSchema={validationCompanySchema}
            validateOnChange={false}
            validateOnBlur={true}
            onSubmit={(values: ICompany) => {
              if (inicialValues.idEmpresa === null) {
                addCompany(values);
              } else {
                values.idEmpresa = inicialValues.idEmpresa;
                editCompany({ ...values, flagAtiva: !values.flagAtiva });
              };

            }}
          >
            {({ handleSubmit, handleChange, values, errors, setFieldError }) => (
              <form onSubmit={handleSubmit}>
                <InputText
                  value={values.codEmpresa}
                  onChange={(e) => { handleChange(e); setFieldError("codEmpresa", "") }}
                  id="codEmpresa"
                  error={errors.codEmpresa ? true : false}
                  name="codEmpresa"
                  type="text"
                  label="Código"
                  helperText={errors.codEmpresa}
                  inputProps={{ maxLength: 5 }}
                  className="mt-2"
                  autoFocus
                />
                <InputText
                  value={values.nomeEmpresa}
                  onChange={(e) => { handleChange(e); setFieldError("nomeEmpresa", "") }}
                  id="nomeEmpresa"
                  error={errors.nomeEmpresa ? true : false}
                  name="nomeEmpresa"
                  type="text"
                  label="Razão Social"
                  helperText={errors.nomeEmpresa}
                  inputProps={{ maxLength: 80 }}
                  className="mt-2"
                />
                {
                  inicialValues.idEmpresa &&
                  <InputCheckbox
                    checked={values.flagAtiva}
                    onChange={handleChange}
                    name="flagAtiva"
                    color="primary"
                    label="Inativar Empresa"
                  />
                }
              </form>
            )}
          </Formik>
        </Panel>

        <CustomDialog
          hidden={!isDialogExcludeOpen}
          onDismiss={() => this.setState({ isDialogExcludeOpen: false })}
          dialogContentProps={dialogContentProps}
        >
          <DefaultButton onClick={() => this.setState({ isDialogExcludeOpen: false })} text="Cancelar" />
          <DeleteButton onClick={() => this.excludeCompanies()} text="Excluir" />
        </CustomDialog>
        <Wrapper>
          <Drawer
            isOpen={filter.isOpen}
            content={
              <ContainerContent>
                <HeaderPage
                  title="Empresas"
                  leftItems={
                    <>
                      <CommandBarButton
                        styles={btnStyle}
                        iconProps={{ iconName: 'Add' }}
                        disabled={companies.loadingData}
                        text="Adicionar Empresa"
                        onClick={() => this.setState(
                          {
                            isPanelOpen: true,
                            inicialValues: initialValue
                          }
                        )}
                      />
                      {this.commandBarRender()}
                    </>
                  }
                  rightItems={
                    <>
                      <SearchBox
                        placeholder="Pesquisar"
                        value={search}
                        onChange={(e) => this.handleSearch(e)}
                        onKeyUp={(e) => this.filter(e.key)}
                        componentRef={this.inputSearch}
                        styles={{
                          root:
                            { border: 'none', width: 200, marginRight: 1 }
                        }}
                      />
                      
                      <CommandBarButton
                        styles={btnStyle}
                        iconProps={{ iconName: 'Refresh' }}
                        text="Atualizar"
                        onClick={() => getCompanies()}
                      />
                      <CommandBarButton
                        styles={btnStyle}
                        iconProps={{ iconName: 'filter' }}
                        text="Filtrar"
                        onClick={() => this.toggleFilter()}
                      />
                    </>
                  }
                />
                {!companies.loadingData && companies.data.length === 0 ?
                  <NoItems
                    error={companies.error}
                    text="Não há empresas cadastradas"
                    img="/static/icons/supermarket.svg"
                    alt="Empresas"
                  />
                  :
                  <ListContainer>
                    <ShimmeredDetailsList
                      items={isFiltering ? items : companies.data}
                      enableShimmer={companies.loadingData}
                      columns={columns}
                      selectionMode={SelectionMode.single}
                      selection={this._selection}
                      getKey={this._getKey}
                      selectionPreservedOnEmptyClick={true}
                      setKey="single"
                      layoutMode={DetailsListLayoutMode.justified}
                      isHeaderVisible={true}
                      onItemInvoked={this._onItemInvoked}
                    />
                  </ListContainer>
                }
              </ContainerContent>
            }>
            <>
              <Stack horizontal horizontalAlign="space-between">
                <Text variant="xLarge">Filtros</Text>
                <Stack horizontal>
                  <IconButton
                    iconProps={{ iconName: 'ChromeClose' }}
                    styles={{ root: { color: colors.darkGray } }}
                    title="Fechar"
                    ariaLabel="Fechar"
                    onClick={() => this.setState({ filter: { ...filter, isOpen: false } })}
                  />
                </Stack>
              </Stack>
              <RadioGroup aria-label="gender" name="gender1" style={{ marginTop: 10 }} value={filter.ativadas} onChange={(e: any) => this.toggleParamsFilter(e.target.value)}>
                <Text variant="mediumPlus">Status</Text>
                <FormControlLabel value="todos" control={<Radio color="primary" />} label="Todos" />
                <FormControlLabel value="ativadas" control={<Radio color="primary" />} label="Ativadas" />
                <FormControlLabel value="desativadas" control={<Radio color="primary" />} label="Desativadas" />
              </RadioGroup>
            </>
          </Drawer>
        </Wrapper>
      </>
    );
  };

  private _onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
    const { columns } = this.state;
    const newColumns: IColumn[] = columns.slice();
    let items: ICompany[] = [];
    if (this.state.isFiltering) {
      items = this.state.items;
    } else {
      items = this.props.companies.data;
    };
    const currColumn: IColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      };
    });
    const newItems = this._sort(items, currColumn.fieldName!, currColumn.isSortedDescending);
    this.setState({
      columns: newColumns,
      items: newItems,
    });
  };

  private _getKey(item: any, index?: number): any {
    if (item !== undefined)
      return item.key;
  };

  private _sort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
    const result = (prop: string, obj: T) => (prop.split('.').reduce((a: any, b: any) => a[b] ?? '', obj))
    return items.sort((a: T, b: T) => ((isSortedDescending ? result(columnKey, a) < result(columnKey, b) : result(columnKey, a) > result(columnKey, b)) ? 1 : -1));
  };

}
const mapStateToProps = (state: RootState) => ({
  companies: state.companiesReducer
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({ ...getCompanies, ...addCompany, ...delCompany, ...editCompany, ...setCurrentPage }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Companies);
